import { render, staticRenderFns } from "./OurStoryHero.vue?vue&type=template&id=3ff99c41&scoped=true&"
import script from "./OurStoryHero.vue?vue&type=script&lang=js&"
export * from "./OurStoryHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff99c41",
  null
  
)

export default component.exports